define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action/Controller",
	"csi/router",
], function(declare, _, Controller, router) {

	return declare(Controller, {
		/**
		 * @override
		 * Navigate to new revision after update
		 */
		postProcessSuccess: function() {
			const master = this.getCache().getNode(this.getParent().__Parent__);
			const revisionUrl = master.Revisions.last();
			return router.setLocationRevisionUrl(revisionUrl);
		}
	});
});